export * from './giveaway-data'
export * from './giveaway-rules'
export * from './giveaway-faqs'
export * from './quantity-multipliers'
export * from './trailer-experiments'
export * from './types'
export {
  GiveawayTabEnum,
  type GiveawayTab,
  type GiveawayConfig,
  type GiveawayHowToStep,
  type PartnerLogo,
  type GiveawayPrizeItem,
  type GalleryImage,
  type GiveawayShare,
  type TicketFlowConfig,
  type QuantityMultiplier,
  type GiveawayRulesConfig,
} from './types'

export type CongratsModal = {
  text: string
  image: string
  alt: string
}

export type SummaryPage = {
  image: string
  alt: string
}

export type ReservationCompletePage = {
  desktopImage: string
  mobileImage: string
  alt: string
  text: string
}

export type NoShowtimes = {
  image: string
  text: string
}
